// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { clicksConfig } from '@/lib/analytics/kpis/pinterest/clicks';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerClicksConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> = {
    ...clicksConfig,
    tooltip: null,
    loader: MediaViewerKpiLoader
};
